import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { AppDispatch } from "@store/store";
import { uploadToS3Thunk } from "@store/thunk/UploadS3Thunk";
import {
  getUploadSignedURLThunk,
  generateEsignRequestThunk,
  fetchRegionalOfficeDetails,
  postCompleteEsignProvisionalThunk,
  fetchbankguaranteedetailsThunk,
  fetchpadetailsThunk,
  fetchROWUploadedDocuments,
} from "../redux/thunk/application-detailThunk";
import { toast } from "react-toastify";
import PrivateLicenseContent from "./PrivateLicenseContent";
import RetailLicenseContent from "./RetailLicenseContent";
import ROWProvisional from "./ROWProvisional";
import RowOfcProvisional from "./RowOfcProvisional";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography, Alert } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LicenseDocuments from "./LicenseDocuments";
import { fetchUploadedDocuments } from "../redux/thunk/application-detailThunk";
import PDFMerger from "pdf-merger-js";
import { fetchProfile } from "@modules/profile/redux/thunk/profileThunk";
import { FeesDetailsThunk } from "@modules/application-section/application-details/redux/services/thunk/DetailsThunk";
import { fetchReceiptDetailsThunk } from "../redux/thunk/application-detailThunk";
// import { encrypt } from "../../../utils/encryptionUtils";
import ROWProvisionalFinalAgreement from "./ROWProvisionalFinalAgreement";
import { PDFDocument } from "pdf-lib";
import { getSignedPreviewUrl } from "../../../utils/getViewSignedUrlHandler";
import {
  getFileROWSignedURLThunk,
  getFileSignedURLThunk,
  getROWFileSignedURLMorthThunk,
} from "@modules/stepper/redux/thunk/documentThunk";
import { productionCheck } from "@components/buttonGroupView/utils";
import { genericUploadThunk } from "../redux/thunk/uploadThunk";
import { getFileSignedURLMorthThunk } from "@modules/stepper/redux/thunk/documentThunk";
import { width } from "@mui/system";

const LicenseSection = ({
  applicantdata,
  esignCompleted,
  esignTmpURL,
  userData,
}: any) => {
  const [roDetails, setRoDetails] = useState<any>(null);
  const [profileData, setProfileData] = useState<any>(null);
  const [bgDetails, setBGDetails] = React.useState<any>(null);
  const [paDetails, setPADetails] = React.useState<any>(null);
  const [feeDetails, setFeeDetails] = React.useState<any>(null);
  const [getFeesDetails, setGetFeesDetails] = React.useState<any>(null);
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const contentRef = useRef<HTMLDivElement>(null);
  const params = new URLSearchParams(location.search);
  const row = params.get("row");
  const access = params.get("access");
  const navigate = useNavigate();
  const [drawingFile, setDrawingFile] = React.useState<Array<{
    upload_path: string;
    media_type: string;
  }> | null>(null);

  const fetchDocuments = async () => {
    if (applicantdata?.id) {
      const fetchedDocs = await dispatch(
        fetchUploadedDocuments({
          access_id: applicantdata?.id,
          amenityCategory: applicantdata?.application_category_id,
        }),
      ).unwrap();
      setDrawingFile(
        fetchedDocs?.files?.filter((doc: any) => doc.media_type === "drw") ||
          [],
      );
    }
    if (applicantdata?.application_id) {
      const fetchedDocs = await dispatch(
        fetchROWUploadedDocuments({
          access_id: applicantdata?.application_id,
          amenityCategory: applicantdata?.application_category_id,
        }),
      ).unwrap();
      setDrawingFile(
        fetchedDocs?.files?.filter((doc: any) => doc.media_type === "drw") ||
          [],
      );
    }
  };

  const blobToBase64 = (blob: Blob) =>
    new Promise<string>((resolve) => {
      const reader = new FileReader();

      reader.onloadend = () => resolve(reader.result as string);

      reader.readAsDataURL(blob);
    });

  useEffect(() => {
    const getProfile = async () => {
      const res = await dispatch(fetchProfile());
      if (
        res?.payload &&
        typeof res.payload === "object" &&
        "data" in res.payload
      ) {
        setProfileData((res.payload as { data: any }).data);
      } else {
        setProfileData(res.payload);
      }
    };
    getProfile();
  }, [dispatch]);

  useEffect(() => {
    if (applicantdata?.id) {
      dispatch(fetchReceiptDetailsThunk(applicantdata?.id)).then((res: any) => {
        if (res.payload?.success && Array.isArray(res.payload.data)) {
          setFeeDetails(res.payload.data);
        }
      });
    }
    if (applicantdata?.application_id) {
      dispatch(fetchReceiptDetailsThunk(applicantdata?.application_id)).then(
        (res: any) => {
          if (res.payload?.success && Array.isArray(res.payload.data)) {
            setFeeDetails(res.payload.data);
          }
        },
      );
    }
  }, [applicantdata?.application_id, applicantdata?.id]);

  React.useEffect(() => {
    fetchDocuments();
  }, [applicantdata]);

  React.useEffect(() => {
    if (row) {
      if (applicantdata?.application_id) {
        dispatch(
          fetchbankguaranteedetailsThunk(applicantdata?.application_id),
        ).then((res: any) => {
          if (res.payload) {
            setBGDetails(res.payload);
          }
        });
      }
    }
    if (access) {
      if (applicantdata?.id) {
        dispatch(fetchbankguaranteedetailsThunk(applicantdata?.id)).then(
          (res: any) => {
            if (res.payload) {
              setBGDetails(res.payload);
            }
          },
        );
      }
    }
  }, [applicantdata?.application_id, applicantdata?.id, dispatch]);

  React.useEffect(() => {
    if (row) {
      if (applicantdata?.application_id) {
        dispatch(fetchpadetailsThunk(applicantdata?.application_id)).then(
          (res: any) => {
            if (res.payload) {
              setPADetails(res.payload);
            }
          },
        );
      }
    }
    if (access) {
      if (applicantdata?.id) {
        dispatch(fetchpadetailsThunk(applicantdata?.id)).then((res: any) => {
          if (res.payload) {
            setPADetails(res.payload);
          }
        });
      }
    }
  }, [applicantdata?.application_id, applicantdata?.id, dispatch]);

  React.useEffect(() => {
    const fetchFeesAmount = async () => {
      if (row) {
        if (applicantdata?.application_id) {
          try {
            const feesAmount = await dispatch(
              FeesDetailsThunk({
                applicationId: applicantdata?.application_id,
              }),
            ).unwrap();
            setGetFeesDetails(feesAmount || {});
          } catch (error) {
            console.error("Error fetching Fees details:", error);
          }
        }
      }
      if (access) {
        if (applicantdata?.id) {
          try {
            const feesAmount = await dispatch(
              FeesDetailsThunk({ applicationId: applicantdata?.id }),
            ).unwrap();
            setGetFeesDetails(feesAmount || {});
          } catch (error) {
            console.error("Error fetching Fees details:", error);
          }
        }
      }
    };
    fetchFeesAmount();
  }, [applicantdata?.application_id, applicantdata?.id, dispatch]);

  // Helper: wait for fonts/images before capture
  const waitForContentReady = async (root: HTMLElement) => {
    // Wait for web fonts
    if ((document as any).fonts?.ready) {
      await (document as any).fonts.ready;
    }
    // Ensure images are loaded and set CORS where possible
    const imgs = Array.from(root.querySelectorAll("img")) as HTMLImageElement[];
    imgs.forEach((img) => {
      // Setting crossOrigin helps when server sends proper CORS headers
      if (!img.crossOrigin) img.crossOrigin = "anonymous";
    });
    await Promise.all(
      imgs.map((img) =>
        img.complete
          ? Promise.resolve()
          : new Promise((resolve) => {
              img.onload = img.onerror = () => resolve(null);
            }),
      ),
    );
    // Small layout settle delay
    await new Promise((r) => setTimeout(r, 100));
  };

  const getObjectKey = (path?: string) => {
    if (!path) return undefined;
    return path.replace(/^(noc-document|morth-documents)\/(row|access)\//, "");
  };

  const getPASignature = async () => {
    try {
      const signature = paDetails?.[0]?.authority_signature;

      if (!signature?.upload_path) return null;

      const signedUrl = await getSignedPreviewUrl({
        document_name: getObjectKey(signature.upload_path),
        dispatch,
        getSignedUrlThunk: getFileSignedURLMorthThunk,
      });

      const response = await fetch(signedUrl);
      const blob = await response.blob();

      return blob;

      // return await response.blob();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const getROSignature = async () => {
    try {
      const signature = roDetails?.authority_signature;

      if (!signature?.upload_path) return null;

      const signedUrl = await getSignedPreviewUrl({
        document_name: getObjectKey(signature.upload_path),
        dispatch,
        getSignedUrlThunk: getFileSignedURLMorthThunk,
      });

      const response = await fetch(signedUrl);
      const blob = await response.blob();

      return blob;

      // return await response.blob();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const appendAuthoritySignatures = async (
    mergedPdf: PDFDocument,
    startPage = 0,
    includePA = true,
    endPage?: number,
  ) => {
    try {
      const [paSignatureBlob, roSignatureBlob] = await Promise.all([
        getPASignature(),
        getROSignature(),
      ]);

      if (!paSignatureBlob && !roSignatureBlob) {
        return;
      }

      const [paEmbeddedSignature, roEmbeddedSignature] = await Promise.all([
        paSignatureBlob
          ? mergedPdf.embedPng(await paSignatureBlob.arrayBuffer())
          : null,
        roSignatureBlob
          ? mergedPdf.embedPng(await roSignatureBlob.arrayBuffer())
          : null,
      ]);

      const authorityFont = await mergedPdf.embedFont("Helvetica-Oblique");

      // const pages = mergedPdf.getPages();
      // const pages = mergedPdf.getPages().slice(startPage);
      const pages = mergedPdf
        .getPages()
        .slice(startPage, endPage !== undefined ? endPage + 1 : undefined);

      // ==========================================
      // SIGNATURE CONFIGURATION
      // ==========================================

      const signatureWidth = 48;

      // IMPORTANT:
      // Do not allow the actual PNG ratio to make
      // the signature block unnecessarily tall.
      const maxSignatureHeight = 18;

      const rightMargin = 8;
      const bottomMargin = 8;

      // Space between image and authority text
      const imageTextGap = 4;

      // Space between PA block and RO block
      const signatureGap = 7;

      const fontSize = 5.5;

      // Fixed height allocated to authority text
      const labelHeight = 7;

      // ==========================================
      // Calculate image dimensions
      // ==========================================

      const getSignatureDimensions = (signature: any) => {
        if (!signature?.width || !signature?.height) {
          return null;
        }

        const ratio = signature.height / signature.width;

        let width = signatureWidth;
        let height = width * ratio;

        // Constrain the height
        if (height > maxSignatureHeight) {
          height = maxSignatureHeight;
          width = height / ratio;
        }

        return {
          width,
          height,
        };
      };

      const paDimensions = getSignatureDimensions(paEmbeddedSignature);
      const roDimensions = getSignatureDimensions(roEmbeddedSignature);

      // ==========================================
      // Text width helper
      // ==========================================

      const getCenteredTextX = (
        pageWidth: number,
        text: string,
        fontSize: number,
      ) => {
        const textWidth = authorityFont.widthOfTextAtSize(text, fontSize);

        return pageWidth - rightMargin - signatureWidth / 2 - textWidth / 2;
      };

      // ==========================================
      // Draw on every page
      // ==========================================

      pages.forEach((page) => {
        const { width: pageWidth } = page.getSize();

        /**
         * Fixed center of the signature column.
         *
         * This means both signatures and both labels
         * are aligned to exactly the same center.
         */
        const signatureCenterX = pageWidth - rightMargin - signatureWidth / 2;

        /**
         * Every signature gets the same fixed block:
         *
         * IMAGE
         * IMAGE
         * IMAGE
         * gap
         * LABEL
         */
        const signatureBlockHeight =
          maxSignatureHeight + imageTextGap + labelHeight;

        /**
         * RO is always the bottom block.
         */
        let blockBottomY = bottomMargin;

        // ==========================================
        // RO SIGNATURE
        // ==========================================

        if (roEmbeddedSignature && roDimensions) {
          /**
           * Image is positioned at the TOP portion
           * of the fixed signature block.
           */
          const roImageY = blockBottomY + labelHeight + imageTextGap;

          const roImageX = signatureCenterX - roDimensions.width / 2;

          page.drawImage(roEmbeddedSignature, {
            x: roImageX,
            y: roImageY,
            width: roDimensions.width,
            height: roDimensions.height,
          });

          /**
           * Label is always at the same fixed position
           * below the signature.
           */
          const roLabel = "Competent Authority Signature";

          const roTextWidth = authorityFont.widthOfTextAtSize(
            roLabel,
            fontSize,
          );

          page.drawText(roLabel, {
            x: signatureCenterX - roTextWidth / 2 - 10, // Adjusted for better centering
            y: blockBottomY,
            size: fontSize,
            font: authorityFont,
          });

          /**
           * Move the next signature block upward.
           */
          blockBottomY += signatureBlockHeight + signatureGap;
        }

        // ==========================================
        // PA SIGNATURE
        // ==========================================

        if (includePA && paEmbeddedSignature && paDimensions) {
          const paImageY = blockBottomY + labelHeight + imageTextGap;

          const paImageX = signatureCenterX - paDimensions.width / 2;

          page.drawImage(paEmbeddedSignature, {
            x: paImageX,
            y: paImageY,
            width: paDimensions.width,
            height: paDimensions.height,
          });

          const paLabel = "Proposing Authority Signature";

          const paTextWidth = authorityFont.widthOfTextAtSize(
            paLabel,
            fontSize,
          );

          page.drawText(paLabel, {
            x: signatureCenterX - paTextWidth / 2 - 10, // Adjusted for better centering
            y: blockBottomY,
            size: fontSize,
            font: authorityFont,
          });
        }
      });
    } catch (error) {
      console.error("Error appending authority signatures:", error);
    }
  };

  const handleGenerateAndUploadPDF = async () => {
    if (!contentRef.current) {
      console.error("Content reference is null");
      return;
    }
    let filename;
    if (applicantdata?.status_id === 6 || applicantdata?.status_id === 76) {
      filename = `provisional-license-${Date.now()}-${Math.random()
        .toString(36)
        .substr(2, 6)}.pdf`;
    }
    if (!filename) return;
    if (filename) {
      await waitForContentReady(contentRef.current);

      // const signatureBlob = await getPASignature();
      let agreementStartRatio = -1;
      let agreementEndRatio = -1;

      const agreementElement = contentRef.current.querySelector(
        ".pdf-agreement-page",
      ) as HTMLElement | null;

      if (agreementElement) {
        const contentRect = contentRef.current.getBoundingClientRect();

        const agreementRect = agreementElement.getBoundingClientRect();

        const contentHeight = contentRef.current.scrollHeight;

        agreementStartRatio =
          (agreementRect.top - contentRect.top) / contentHeight;

        agreementEndRatio =
          (agreementRect.bottom - contentRect.top) / contentHeight;
      }
      const canvas = await html2canvas(contentRef.current, {
        scale: 2, // Reduce scale to lower resolution
        useCORS: true,
        width: contentRef.current.scrollWidth,
      });
      contentRef.current.style.margin = "0";
      contentRef.current.style.padding = "0";
      contentRef.current.style.width = "100%";
      const imgData = canvas.toDataURL("image/jpeg", 0.4); // Use JPEG format with 70% quality
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      let agreementStartPage = -1;
      let agreementEndPage = -1;

      if (agreementStartRatio >= 0 && agreementEndRatio >= 0) {
        const agreementStartY = agreementStartRatio * imgHeight;

        const agreementEndY = agreementEndRatio * imgHeight;

        const agreementPageShift = agreementStartY % pdfHeight > 0 ? 1 : 0;

        agreementStartPage =
          Math.floor(agreementStartY / pdfHeight) + agreementPageShift;

        agreementEndPage =
          Math.ceil(agreementEndY / pdfHeight) - 1 + agreementPageShift;
      }

      // html2canvas renders one long image, so CSS page-break rules alone are
      // not enough. Keep the NOC content intact, then start the agreement on
      // the next PDF page.
      const agreementStartY =
        agreementStartRatio >= 0 ? agreementStartRatio * imgHeight : -1;
      const hasAgreement = agreementStartY > 0 && agreementStartY < imgHeight;

      let heightLeft = imgHeight;
      let position = 0;

      // Small top gap on every continued PDF page so text does not touch/cut at the page edge.
      const continuationTopGap = 2.5;

      // Render all complete NOC pages before the page where the agreement starts.
      if (hasAgreement) {
        const nocFullPages = Math.floor(agreementStartY / pdfHeight);

        for (let pageIndex = 0; pageIndex < nocFullPages; pageIndex += 1) {
          if (pageIndex > 0) pdf.addPage();
          position = -(pageIndex * pdfHeight) + continuationTopGap;
          pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        }

        // If the agreement starts part-way through a page, keep the remaining
        // NOC text on that page and mask only the agreement portion.
        const nocRemainder = agreementStartY % pdfHeight;
        if (nocRemainder > 0) {
          pdf.addPage();
          const nocPageOffset = agreementStartY - nocRemainder;
          pdf.addImage(
            imgData,
            "JPEG",
            0,
            -nocPageOffset + continuationTopGap,
            imgWidth,
            imgHeight,
          );

          pdf.setFillColor(255, 255, 255);
          pdf.rect(
            0,
            nocRemainder + continuationTopGap,
            pdfWidth,
            pdfHeight - nocRemainder - continuationTopGap,
            "F",
          );
        }

        // Agreement starts cleanly at the top of a new PDF page.
        pdf.addPage();
        pdf.addImage(
          imgData,
          "JPEG",
          0,
          -agreementStartY + continuationTopGap,
          imgWidth,
          imgHeight,
        );

        const agreementImgHeight = imgHeight - agreementStartY;
        let agreementHeightLeft = agreementImgHeight - pdfHeight;
        let agreementOffset = agreementStartY + pdfHeight;

        while (agreementHeightLeft > 0) {
          pdf.addPage();
          pdf.addImage(
            imgData,
            "JPEG",
            0,
            -agreementOffset + continuationTopGap,
            imgWidth,
            imgHeight,
          );
          agreementHeightLeft -= pdfHeight;
          agreementOffset += pdfHeight;
        }
      } else {
        // Existing behaviour for documents without an agreement section.
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;

        while (heightLeft > 0) {
          position = heightLeft - imgHeight + continuationTopGap;
          pdf.addPage();
          pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
          heightLeft -= pdfHeight;
        }
      }

      // Now add signature on the LAST page (current page after loop)
      const pageHeight = pdf.internal.pageSize.getHeight();
      const pageWidth = pdf.internal.pageSize.getWidth();

      // Signature dimensions - positioned from bottom
      const bottomMargin = 40; // 40mm from bottom
      const boxX = 10;
      const boxY = pageHeight - bottomMargin; // Calculate from bottom

      // Set text color to black
      (pdf as any).internal.write("3 Tr");
      pdf.setTextColor(255, 255, 255);
      // Add signature label on last page
      pdf.setFontSize(6);
      pdf.setFont("helvetica", "bold");
      pdf.text("---- Applicant Digital Signature ----", boxX, boxY);

      pdf.setTextColor(0, 0, 0);
      pdf.setFont("helvetica", "normal");

      // Convert to arraybuffer BEFORE appending drawing files
      const generatedPdfArrayBuffer = pdf.output("arraybuffer");
      const mainPdfDoc = await PDFDocument.load(generatedPdfArrayBuffer);
      const templatePageCount = mainPdfDoc.getPageCount();

      await appendAuthoritySignatures(
        mainPdfDoc,
        0, // start from first template page
        false, // RO only, no PA
        agreementStartPage - 1,
      );

      if (agreementStartPage >= 0 && agreementEndPage >= agreementStartPage) {
        await appendAuthoritySignatures(
          mainPdfDoc,
          agreementStartPage,
          true, // PA + CA
          agreementEndPage,
        );
      }

      await appendAuthoritySignatures(
        mainPdfDoc,
        0, // start from first template page
        false, // RO only, no PA
      );
      if (drawingFile) {
        await Promise.all(
          drawingFile.map(async (doc) => {
            const fileUrl = await getSignedPreviewUrl({
              document_name: getObjectKey(doc?.upload_path),
              dispatch,
              getSignedUrlThunk: row
                ? getFileROWSignedURLThunk
                : getFileSignedURLThunk,
            });

            try {
              const response = await fetch(fileUrl);
              const pdfArrayBuffer = await response.arrayBuffer();
              const additionalPdfDoc = await PDFDocument.load(pdfArrayBuffer);
              const copiedPages = await mainPdfDoc.copyPages(
                additionalPdfDoc,
                additionalPdfDoc.getPageIndices(),
              );
              copiedPages.forEach((page) => mainPdfDoc.addPage(page));
            } catch (error) {
              console.error(`Failed to fetch or add PDF: ${fileUrl}`, error);
            }
          }),
        );
        // if (signatureBlob) {
        //   const signatureBytes = await signatureBlob.arrayBuffer();

        //   const embeddedSignature =
        //     paDetails?.[0]?.authority_signature?.mimetype?.includes("png")
        //       ? await mainPdfDoc.embedPng(signatureBytes)
        //       : await mainPdfDoc.embedJpg(signatureBytes);

        //   const pages = mainPdfDoc.getPages();

        //   pages.forEach((page) => {
        //     const { width, height } = page.getSize();

        //     const imgWidth = 60;

        //     const scale = embeddedSignature.height / embeddedSignature.width;

        //     const imgHeight = imgWidth * scale;

        //     page.drawImage(embeddedSignature, {
        //       x: width - imgWidth - 5,
        //       y: 3,
        //       width: imgWidth,
        //       height: imgHeight,
        //     });
        //   });
        // }
      }
      // await appendAuthoritySignatures(mainPdfDoc);

      // ==========================================
      // 1. Add RO signature to TEMPLATE pages only
      // ==========================================

      // ==========================================
      // 2. Append DRAWING documents
      // ==========================================

      if (drawingFile?.length) {
        await Promise.all(
          drawingFile.map(async (doc) => {
            const fileUrl = await getSignedPreviewUrl({
              document_name: getObjectKey(doc?.upload_path),
              dispatch,
              getSignedUrlThunk: row
                ? getFileROWSignedURLThunk
                : getFileSignedURLThunk,
            });

            try {
              const response = await fetch(fileUrl);
              const pdfArrayBuffer = await response.arrayBuffer();

              const additionalPdfDoc = await PDFDocument.load(pdfArrayBuffer);

              const copiedPages = await mainPdfDoc.copyPages(
                additionalPdfDoc,
                additionalPdfDoc.getPageIndices(),
              );

              copiedPages.forEach((page) => {
                mainPdfDoc.addPage(page);
              });
            } catch (error) {
              console.error(`Failed to fetch or add PDF: ${fileUrl}`, error);
            }
          }),
        );

        // ==========================================
        // 3. Add PA + RO to DRAWING pages only
        // ==========================================

        await appendAuthoritySignatures(
          mainPdfDoc,
          templatePageCount, // skip template pages
          true, // PA + RO
        );
      }
      let pdfFile;
      // Merge all PDFs and download the result
      const mergedPdfArrayBuffer = await mainPdfDoc.save();
      const mergedPdfBlob = new Blob([mergedPdfArrayBuffer as any], {
        type: "application/pdf",
      });
      pdfFile = new File([mergedPdfBlob], filename, {
        type: "application/pdf",
      });

      // if (row) {
      //   // const pdfBlob = pdf.output("blob");
      //   pdfFile = new File([pdfBlob], filename, { type: "application/pdf" });
      // }
      // if (access) {
      //   pdfFile = new File([mergedPdfBlob], filename, {
      //     type: "application/pdf",
      //   });
      // }
      const fileURL: any = await getFileURL(
        filename,
        row ? "row" : "access",
        pdfFile as File,
        "application/pdf",
        true, // isEsign = true
      );
      if (!pdfFile) {
        toast.error(
          "Unable to prepare PDF file. Missing moduletype in URL (row/access).",
        );
        return;
      }
      // pdf.save(filename);
      // if (pdfFile) {
      //   const url = URL.createObjectURL(pdfFile);
      //   const a = document.createElement("a");
      //   a.href = url;
      //   a.download = filename;
      //   document.body.appendChild(a);
      //   a.click();
      //   document.body.removeChild(a);
      //   URL.revokeObjectURL(url);
      // }
      // return;
      if (
        (fileURL?.payload?.success && pdfFile) ||
        fileURL?.payload?.data?.signedUrl
      ) {
        if (!productionCheck) {
          await dispatch(
            uploadToS3Thunk({
              signedUrl: fileURL?.payload?.data?.signedUrl,
              file: pdfFile,
              contentType: "application/pdf",
            }),
          );
        }
        let generateEsignRequestResponse;
        let moduletype = row ? "row" : "access";
        if (applicantdata?.status_id === 6 || applicantdata?.status_id === 76) {
          const constructedFileURL =
            process.env.REACT_APP_API_BASE_URL +
            `/backend/api/file/download-file-signed-url?fileName=${fileURL?.payload?.data?.fileName}&moduletype=${moduletype}`;

          generateEsignRequestResponse = await dispatch(
            generateEsignRequestThunk({
              ...(!productionCheck && {
                fileURL: constructedFileURL,
              }),
              fileName: fileURL?.payload?.data?.fileName,
              application_id: row
                ? applicantdata?.application_id
                : applicantdata?.id,
              moduletype,
              username: profileData?.name || "",
            }),
          );
        }
        if (generateEsignRequestResponse?.payload?.success === false) {
          toast.error("Error in generating eSign request. Please try again.");
        } else {
          const htmlContent = generateEsignRequestResponse?.payload;
          document.open();
          document.write(htmlContent);
          document.close();
        }
      }
    }
  };

  const getFileURL = async (
    filename: string,
    moduletype: any,
    pdf: File,
    contentType: string,
    isEsign?: boolean,
  ) => {
    // if (pdf.size > 21 * 1024 * 1024) {
    //   toast.error("File size must be less than 20 MB");
    //   return;
    // }
    // console.log("isEsign", isEsign);
    const resultAction = await dispatch(
      genericUploadThunk({
        file: pdf,
        moduleType: moduletype,
        isEsign: isEsign || false,
      }),
    );
    return resultAction;
  };

  useEffect(() => {
    if (!applicantdata) return;
    const getRODetails = async () => {
      const res = await dispatch(
        fetchRegionalOfficeDetails(
          row ? applicantdata?.application_id : applicantdata?.id,
        ),
      );
      if (res?.payload) {
        setRoDetails(res.payload);
      }
    };
    getRODetails();
  }, [dispatch, applicantdata]);

  // console.log("applicantdata", applicantdata);

  return (
    <>
      <div style={{ position: "relative" }}>
        {esignCompleted && (
          <Alert
            severity="success"
            icon={
              <Box
                sx={{
                  width: 26,
                  height: 26,
                  borderRadius: "50%",
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <NotificationsIcon sx={{ color: "#78af7b", fontSize: 20 }} />
              </Box>
            }
            sx={{
              mb: 3,
              alignItems: "center",
              backgroundColor: "#78af7b",
              color: "#fff",
              borderRadius: 2,
              height: 45,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontStyle: "normal",
                fontSize: "14px",
                lineHeight: "100%",
                letterSpacing: "0px",
              }}
            >
              Congratulations! Your license document has been successfully
              e-signed. You may now proceed to complete the application.
            </Typography>
          </Alert>
        )}
        {esignCompleted ? (
          <>
            <embed
              src={process.env.REACT_APP_API_IMAGE_URL + "/" + esignTmpURL}
              type="application/pdf"
              style={{ width: "100%", height: "60rem", border: "none" }}
              title="PDF Viewer"
            />
          </>
        ) : (
          <>
            <div style={{ position: "relative", minWidth: "100rem" }}>
              <div ref={contentRef} className="main-content-wrapper" style={{}}>
                <div id="license-agreement">
                  {applicantdata?.status_id === 6 ||
                  applicantdata?.status_id === 76 ? (
                    row !== null ? (
                      applicantdata?.amenity_id === 4 ||
                      applicantdata?.amenity_id === 35 ||
                      applicantdata?.amenity_id === 36 ||
                      applicantdata?.amenity_id === 16 ||
                      applicantdata?.amenity_id === 5 ||
                      applicantdata?.amenity_id === 17 ? (
                        <>
                          <RowOfcProvisional
                            feeDetails={feeDetails}
                            applicantdata={applicantdata}
                            roDetails={roDetails}
                            userData={userData}
                            bgDetails={bgDetails}
                            paDetails={paDetails}
                            getFeesDetails={getFeesDetails}
                          />
                        </>
                      ) : (
                        <>
                          <ROWProvisional
                            feeDetails={feeDetails}
                            applicantdata={applicantdata}
                            roDetails={roDetails}
                            userData={userData}
                          />
                        </>
                      )
                    ) : access !== null ? (
                      applicantdata?.application_category_id === 1 ? (
                        <RetailLicenseContent
                          feeDatails={feeDetails}
                          userData={userData}
                          applicantdata={applicantdata}
                          roDetails={roDetails}
                          bgDetails={bgDetails}
                          paDetails={paDetails}
                        />
                      ) : applicantdata?.application_category_id === 2 ? (
                        <PrivateLicenseContent
                          feeDatails={feeDetails}
                          userData={userData}
                          applicantdata={applicantdata}
                          roDetails={roDetails}
                          bgDetails={bgDetails}
                          paDetails={paDetails}
                        />
                      ) : null
                    ) : null
                  ) : null}
                </div>
              </div>
              <LicenseDocuments drawingFile={drawingFile} />
              <Box
                sx={{
                  pointerEvents: "none",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  userSelect: "none",
                }}
              >
                <Typography
                  color="error"
                  sx={{
                    position: "absolute",
                    top: 800,
                    left: 0,
                    fontWeight: 700,
                    fontSize: { xs: 24, md: 40 },
                    opacity: 0.4,
                    transform: "rotate(-25deg)",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  This document is a template preview and is not a valid NOC
                </Typography>
              </Box>
            </div>
          </>
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            borderTop: "1px solid #e0e0e0",
            bgcolor: "#fff",
            pt: 2,
            width: "100%",
            px: { xs: 2, sm: 3, md: 3, lg: 3, xl: 3 },
            mx: { xs: -2, sm: -3, md: -3, lg: -1, xl: -3 },
          }}
        >
          <Button
            variant="outlined"
            color="inherit"
            sx={{
              borderRadius: "50px",
              textTransform: "none",
              px: 3,
            }}
            onClick={() => {
              navigate("/application-dashboard");
            }}
          >
            Cancel
          </Button>
          {esignCompleted ? (
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#3A1C73",
                borderRadius: "50px",
                textTransform: "none",
              }}
              onClick={async () => {
                const result = await dispatch(
                  postCompleteEsignProvisionalThunk({
                    application_id:
                      applicantdata.id || applicantdata.application_id,
                    userId: profileData?.id,
                  }),
                ).unwrap();
                if (result?.success && result?.data) {
                  toast.success("E-Sign process completed successfully.");
                  navigate(
                    `${process.env.REACT_APP_API_BASE_URL}/application-submitted?id=${applicantdata?.application_code}`,
                    {
                      state: { isPaymentDone: true },
                    },
                  );
                }
              }}
            >
              Complete
            </Button>
          ) : (
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#3A1C73",
                borderRadius: "50px",
                textTransform: "none",
              }}
              onClick={handleGenerateAndUploadPDF}
            >
              Proceed to E-Signature
            </Button>
          )}
        </Box>
      </div>
    </>
  );
};

export default LicenseSection;
